import {Component, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {RouterService} from '../RouterService';

declare var initScript: any;

@Component({
    selector: 'app-services',
    templateUrl: './services.component.html',
    styleUrls: ['./services.component.css']
})
export class ServicesComponent implements OnInit {

  title = 'Services';

  constructor(private titleService: Title, public routerService: RouterService) {
    titleService.setTitle(this.title);
  }

    ngOnInit(): void {
    }

    redirect(url: string): void {
        this.routerService.redirect(url);
    }
}
